// extracted by mini-css-extract-plugin
export default {"clock":"clock_clock__+GxYu","active":"clock_active__RlvHW","hidden":"clock_hidden__tts4X"};